import React, { useEffect, useState } from "react";
import { Button, SelectPickerInput } from "@shared/components";
import { changeListeners, FieldErrorMessage, formSubmitHandler, schemaValidators, useAppForm } from "@shared/form";
import { Survey } from "@shared/models";
import { Option } from "@shared/interfaces";
import { AssignSurveyDto } from "@containers/User/interfaces/UserForm.interface";

import { getInitValues, validationSchema, prepareSubmitValue } from "./formHelpers";

import "./index.scss";

interface AssignSurveyFormProps {
  surveys: Survey[];
  onChangeForm: () => void;
  onCloseForm: () => void;
  onSubmitForm: (payload: Omit<AssignSurveyDto, "user_id">) => void;
}

const AssignSurveyForm: React.FunctionComponent<AssignSurveyFormProps> = (props) => {
  const { onChangeForm, onCloseForm, onSubmitForm, surveys } = props;
  const [surveyOptions, setSurveyOptions] = useState<Option<number>[]>([]);

  useEffect(() => {
    if (surveys.length) {
      const surveyOpt = surveys.map((i) => {
        return {
          label: i.name,
          value: i.id,
        };
      });
      setSurveyOptions(surveyOpt);
    }
  }, [surveys]);

  const form = useAppForm({
    defaultValues: getInitValues(),
    validators: schemaValidators(validationSchema),
    listeners: changeListeners(onChangeForm),
    onSubmit: ({ value }) => {
      onSubmitForm(prepareSubmitValue(value));
    },
  });

  return (
    <div className="assign-survey-form">
      <form onSubmit={formSubmitHandler(form)}>
        <div className="assign-survey-form-content">
          <div className="survey-input-wrapper">
            {/* The picker holds a one-item array, which the scalar `field.Select` adapter cannot, so it is wired here. */}
            <form.AppField name="surveys">
              {(field) => (
                <>
                  <div className="survey-input">
                    <SelectPickerInput
                      searchable={false}
                      name={field.name}
                      cleanable={false}
                      data={surveyOptions}
                      onChange={(value: number) => field.handleChange([value])}
                      labelTitle="Survey"
                      value={field.state.value[0]}
                      placeholder="Survey"
                    />
                  </div>
                  <FieldErrorMessage />
                </>
              )}
            </form.AppField>
          </div>
        </div>

        <div className="assign-survey-form-footer">
          <Button type="button" className="close-btn margin-right" onClick={() => onCloseForm()}>
            Cancel
          </Button>
          <Button type="submit" className="accent padding">
            Assign Survey
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AssignSurveyForm;
